import { render, staticRenderFns } from "./ParticipantsTable.vue?vue&type=template&id=47395c9c"
import script from "./ParticipantsTable.vue?vue&type=script&lang=js"
export * from "./ParticipantsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports